import React, { useState, useCallback } from 'react';
import { Form, Input, Button, Tooltip, message } from 'antd';
import { passportRoot } from '@liepin/js-core4c-fe';
import classnames from 'classnames';
import stringUtil from '@liepin/native-ltcore4c-pc/lib/string'
import { loginByAccount } from '@liepin/js-login-api-fe'
import useLogin from '../../hooks/use-login';
import SvgQuestion from '../../image/question.svg';
import ValidatorMessage from '../ValidatorMessage';
import styled from '../Reg/index._less';


export default () => {

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [formData, setFormData] = useState({});  // 预留的初始值
  const [ form ] = Form.useForm();
  const { checkedAgreement, isModal, loginSuccess, loginError } = useLogin();


  const handleSave = useCallback(async () => {
    try {
      const values = await form.validateFields();
      if (!checkedAgreement) {
        message.error('请阅读并勾选同意猎聘相关服务协议');
        return;
      }
      const submitData = {
        _bi_source: 0,
        _bi_role: 0,
        pwd: stringUtil.md5(values.pwd),
        login: values.login,
      }
      loginByAccount(submitData)
      .then(loginSuccess)
      .catch(loginError)
    } catch (error) {
    }
  }, [form, checkedAgreement, loginSuccess, loginError])

  const accountSuffix = useCallback(() => {
    return (
      <div className="account-tips">
        <Tooltip placement="bottom" title='非中国大陆手机号请在号码前输入00开头国家/地区代码，例如：美国001'>
          <SvgQuestion />
        </Tooltip>
      </div>
    )
  }, [])

  return (
    <>
      <div className={ classnames("login-container", { 'login-container-modal': isModal, 'login-container-component': !isModal }) }>
        <Form
          form={ form }
          initialValues={ formData }
          size="large"
        >
          <Form.Item
            name="login"
            rules = {[{
              required: true,
              message: <ValidatorMessage text="请输入邮箱/手机号" />
            }]}
          >
            <Input
              data-nick="login-user"
              placeholder="邮箱/手机号"
              suffix={ accountSuffix() }
              autoComplete="off"
              size="large"
            />
          </Form.Item>
          <Form.Item
            name="pwd"
            className="form-item-pwd"
            rules = {[{
              required: true,
              message: <ValidatorMessage text="请输入密码" />
            }]}
          >
            <Input
              data-nick="login-pwd"
              placeholder="密码"
              type="password"
              suffix={
                <a
                  href={ `${passportRoot}/forgetpwd/v1/index` }
                  className="get-pwd-btn"
                  target="_blank"
                  rel="nofollow"
                >找回密码</a>
              }
              autoComplete="off"
              size="large"
            />
          </Form.Item>
          {
            isModal
            ? <div className="bottom-switch-type">
              <a href={ `${passportRoot}/account/v1/hlogin` }>我是猎头</a>
              <a href={ `${passportRoot}/account/v1/elogin` }>我是招聘方</a>
            </div>
            : ''
          }
          <Button onClick={ handleSave } shape="round" className="login-submit-btn" size="large" type="primary">登录</Button>
        </Form>
      </div>
    
      <style jsx>{ styled }</style>
    </>
  )
}
